<template>
  <div class="install">
    <h4 v-if="steps[step]">
      {{ partner.name }} -
      {{ step | setText(steps[step].title) }}
    </h4>
    <div v-if="done">
      <h4>{{ "order_done" | setText("Заказ выполнен") }}</h4>
    </div>
    <template v-for="(value, stepKey) in steps">
      <template v-if="step == stepKey">
        <component
          :createTransaction="createTransaction"
          :updateOrder="updateOrder"
          :transaction="transaction"
          :order="order"
          :partner="partner"
          :partner_id="partner_id"
          :is="stepKey"
          @setStep="setStep"
          :key="stepKey"
          v-model="body"
        />
      </template>
    </template>

    <contract-cancel
      v-if="!done && transaction && transaction.exchange_id"
      :createTransaction="createTransaction"
      :updateOrder="updateOrder"
      :transaction="transaction"
      :order="order"
      :partner="partner"
      :partner_id="partner_id"
      @setStep="setStep"
      v-model="body"
    />
  </div>
</template>
<script>
export default {
  name: "variant",
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    setStep(step = null) {
      if (!step) {
        this.$emit("close", true);
      } else {
        this.step = step;
      }
    },
  },
  components: {
    "client-info": () => import("./ClientInfo"),
    "contract-cancel": () => import("./ContractCancel"),
    "client-create": () => import("./ClientCreate"),
    "client-open": () => import("./ClientOpen"),
    "application-add-card": () => import("./ApplicationAddCard"),
    "application-scoring": () => import("./ApplicationScoring"),
    "contract-purchase": () => import("./ContractPurchase"),
    "contract-upload-photo": () => import("./ContractUploadPhoto"),
    "contract-sign": () => import("./ContractSign"),
  },
  created() {
    try {
      if (
        this.transaction &&
        this.transaction.step &&
        this.steps[this.transaction.step]
      ) {
        this.step = this.transaction.step;
      }
    } catch (error) {}
  },
  computed: {
    done() {
      return (
        this.transaction &&
        this.transaction.system_confirmed &&
        this.transaction.client_confirmed &&
        this.transaction.status > -1
      );
    },
  },
  data() {
    return {
      body: null,
      // step: "client-info",
      step: "client-create",
      steps: {
        "client-info": {
          title: "Информация о клиенте",
        },
        "client-create": {
          title: "Создание клиента",
        },
        "client-open": {
          title: "Детали клиента",
        },
        "application-add-card": {
          title: "Добавление пластиновой карты",
        },
        "application-scoring": {
          title: "Скоринг",
        },
        "contract-purchase": {
          title: "Добавление товаров",
        },
        "contract-upload-photo": {
          title: "Загрузка фотографии клиента и товара",
        },
        "contract-sign": {
          title: "Подпись договора",
        },
      },
    };
  },
};
</script>

